import { AxiosResponse } from 'axios'
import { makeAPIRequest } from '../utils/request';
import { CreateUpdateFormDataForSubmit } from '../components/EntityManagement/Users/AddUser';

interface GetAllEntityUsersParams {
  page: number;
  pageSize: number;
  searchData: {
    entityId?: string, name?: string
  }
};

interface GetAllEntityUsersResponse {
  count: number;
  rows: [];
};

interface GetEntityUserByIdResponse {
  data:{ name?: string}
};

interface ResendInvitationParams {
  id: string;
};

interface ResendInvitationOTPParams {
  id: string;
  phone: string;
  countryCode: string;
};

interface CommonResponse {
  data:{}
};

class EntityUserAPI {

  async getAllEntityUsers(params: GetAllEntityUsersParams): Promise<GetAllEntityUsersResponse> {
    const jwt = localStorage.getItem('access-token');

    const queryParams: Record<string, string> = {};

    // Include pagination if provided
    if (params.page !== undefined && params.pageSize !== undefined) {
      queryParams.offset = (params.page * params.pageSize).toString();
      queryParams.limit = params.pageSize.toString();
    }

    // Include search params if available
    if (params.searchData) {
      Object.entries(params.searchData).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams[key] = value.toString();
        }
      });
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/users?${queryString}` : `/api/users`;

    const res: AxiosResponse = await makeAPIRequest({
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });

    return res.data.data;
  }

  async createEntityUser(data: CreateUpdateFormDataForSubmit): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: `/api/users/invite`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async updateEntityUser(entityUserId: string, data: CreateUpdateFormDataForSubmit): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'PUT',
      url: `/api/users/${entityUserId}`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async getEntityUserById(entityUserId: string): Promise<GetEntityUserByIdResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'GET',
      url: `/api/users/${entityUserId}/detail`,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async enabledDisabledEntityUser(entityUserId: string, data: {enabled: boolean}): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'PUT',
      url: `/api/users/${entityUserId}/activateOrDeactivateAccount`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async resendInvitation(data: ResendInvitationParams): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: `/api/auth/resendInvitation`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };

  async resendInvitationOtp(data: ResendInvitationOTPParams): Promise<CommonResponse> {
    const jwt = localStorage.getItem('access-token')
    const res: AxiosResponse = await makeAPIRequest({
      method: 'POST',
      url: `/api/auth/resendOtp`,
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
    return res.data
  };
}

const entityUserApi = new EntityUserAPI();
export default entityUserApi